import { TextEditor } from "@spz/ui/components/text-editor";
import type { JSONContent } from "@tiptap/core";

type ActivityCommentItemDisplayProps = {
  id: string;
  content: JSONContent;
};

export const ActivityCommentItemDisplay: React.FC<
  ActivityCommentItemDisplayProps
> = ({ id, content }) => {
  return <TextEditor key={id} initialContent={content} readOnly />;
};
